module.exports = __webpack_public_path__ + "img/ssao_only.1343406d.png";